import '../../../../src/assets/stylus/ui/_button.scss'

export default {
  name: 'j-button',
  emits: ['click'],
  props: {},
  render() {
    return (
      <button
        class="j_button"
        type="button"
        onClick={() => this.$emit('click')}
        v-ripple
      >
        {this.$slots.default ? this.$slots.default() : null}
      </button>
    )
  }
}
